import { useDrop } from 'react-dnd';
import { alpha, Box } from '@mui/material';
import React, { useEffect, useRef } from 'react';
import { ReportContentNS } from 'components/report-content/index';
import AllowedComponentType = ReportContentNS.AllowedComponentType;
import useBundleTranslation from 'i18n';

export function ContentDropBox({
    isIconDragging,
    blockIndex,
    onAddNewBlock,
}: {
    isIconDragging?: boolean;
    blockIndex: number;
    onAddNewBlock: (component: AllowedComponentType, index: number) => void;
}) {
    const { t } = useBundleTranslation(['components/report-content']);
    const [{ isOver }, drop] = useDrop(
        () => ({
            accept: 'component',
            canDrop: () => true,
            drop: (obj: AllowedComponentType) => {
                onAddNewBlock(obj, blockIndex);
            },
            collect: (monitor) => ({
                isOver: !!monitor.isOver(),
                canDrop: !!monitor.canDrop(),
            }),
        }),
        [blockIndex],
    );

    return (
        <Box
            ref={drop}
            className={`${isIconDragging ? 'drop-area-active' : ''} ${isOver ? 'drop-area-over' : ''}`}
            sx={{
                width: '100%',
                height: '16px',
                display: 'flex',
                alignItems: 'center',
                position: 'relative',
                '&.drop-area-active:before': {
                    content: "''",
                    width: '100%',
                    height: '36px',
                    top: '-10px',
                    position: 'absolute',
                },
                '&.drop-area-over:after': {
                    content: "''",
                    width: '100%',
                    backgroundColor: (theme) => alpha(theme.palette.primary.main, 0.64),
                    height: '4px',
                },
            }}
            data-test={'drop-components-area'}
        />
    );
}
